import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BuyOrRedeemComponent } from './buy-or-redeem.component';
import { BackButtonModule } from 'src/app/components/back-button/back-button.component.module';
import { BuyLearnMoreComponent } from 'src/app/components/buy-learn-more/buy-learn-more.component';
import { BuyLearnMoreModule } from 'src/app/components/buy-learn-more/buy-learn-more.component.module';
import { CaptureEmailModalModule } from 'src/app/components/capture-email-modal/capture-email-modal.module';
import { CaptureEmailModalComponent } from 'src/app/components/capture-email-modal/capture-email-modal.component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        RouterModule.forChild([{ path: '', component: BuyOrRedeemComponent }]),
        TranslateModule,
        BackButtonModule,
        BuyLearnMoreModule,
        CaptureEmailModalModule
    ],
    declarations: [BuyOrRedeemComponent],
    entryComponents: [BuyLearnMoreComponent, CaptureEmailModalComponent]
})
export class BuyOrRedeemModule { }
